// 🔹 React Core
import React, { useState } from "react";

// 🔹 UI Component Libraries
import { Input, Modal } from "antd";

// 🔹 State Management
import { RootState, useAppDispatch, useAppSelector } from "../../../../store";

// 🔹 Internal Components
import { BtnLoader } from "../../../../Components/Components";

// 🔹 Redux Actions
import {
  GetDeliveryMarkupAPI,
  UpdateDeliveryMarkupAPI,
} from "../../../Redux/deliveryPricing";

// 🔹 Assets
import { svg } from "../../../../Assets/svg";
import { useEffect } from "react";

const DeliveryMarkup: React.FC<{
  setState: React.Dispatch<React.SetStateAction<boolean>>;
  options: any; // { key, value, title, input_title }
  onSuccess: () => void;
}> = ({ setState, options, onSuccess }) => {
  // Descruture
  const { open } = options || {};

  // Use
  const dispatch = useAppDispatch();

  // Selector
  const { updateDeliveryMarkupLoading, getDeliveryMarkupLoading } =
    useAppSelector((state: RootState) => state?.loading);

  const { DeliveryMarkupPercentage } = useAppSelector(
    (state: RootState) => state?.deliveryPricing,
  );

  // Data
  const [deliveryMarkup, setDeliveryMarkup] = useState<string | "">("");

  // Handler
  const onClose = () => {
    setState(false);
  };

  useEffect(() => {
    if (open) {
      setDeliveryMarkup(DeliveryMarkupPercentage?.toString() || "0");
    } else {
      setDeliveryMarkup("");
    }
  }, [open, DeliveryMarkupPercentage]);

  const handleSave = () => {
    if (!deliveryMarkup) return;
    const payload = {
      percentage: Number(deliveryMarkup),
    };
    dispatch(
      UpdateDeliveryMarkupAPI(payload, () => {
        onSuccess();
        onClose();
      }) as any,
    );
  };

  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Update Delivery Markup
        </div>
      }
      open={open}
      onCancel={onClose}
      width={"35rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
            disabled={updateDeliveryMarkupLoading}
          >
            CANCEL
          </button>
          <button
            type="submit"
            form="submitEditVariable"
            disabled={updateDeliveryMarkupLoading}
            className={`btn btn-lg min-w-130 btn-primary`}
            onClick={handleSave}
          >
            {updateDeliveryMarkupLoading ? <BtnLoader /> : "UPDATE"}
          </button>
        </div>
      }
      className="custom-modal"
    >
      <div className="page-form">
        <p className="text-center">
          Updating the delivery markup will recalculate delivery charges
          accordingly. Please confirm to continue.
        </p>

        <div className="form-item">
          <label className="custom-label mb-1 ff">Delivery Markup</label>
          <Input
            name="pallet_price"
            type="number"
            placeholder="Enter Delivery Markup"
            value={deliveryMarkup}
            onChange={(e) => setDeliveryMarkup(e.target.value)}
            className="form-control form-control-lg "
            prefix={<span className="text-white">%</span>}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeliveryMarkup;
